import axios from "axios";

const client = axios.create({
  baseURL: `${process.env.VUE_APP_APIURL}/api/app/obituary-member`
});

//상주 저장
const requestUserSave = async params => {
  return client
    .post(`/update/user`, params)
    .then(res => {
      const { data } = res;

      if (data.code === "0000") {
        return data;
      }

      alert("상주 저장을 실패하였습니다");
      return null;
    })
    .catch(err => {
      alert("상주 저장을 실패하였습니다");
      console.error(err);
    });
};

//상주 삭제
const requestUserDelete = async params => {
  return client
    .post(`/delete/user`, params)
    .then(res => {
      const { data } = res;

      if (data.code === "0000") {
        return data;
      }

      return null;
    })
    .catch(err => {
      alert("상주 삭제를 실패하였습니다");
      console.error(err);
    });
};

const requestUserBankDelete = async params => {
  return client
    .post(`/bank/delete`, params)
    .then(res => {
      const { data } = res;

      return data;
    })
    .catch(err => {
      alert("계좌 삭제를 실패하였습니다");
      console.error(err);
    });
};

// 각종 메시지 (알림톡, 문자, 답례글 ) 보내기
const requestSendMessage = async params => {
  return client
    .post(`/send/message`, params)
    .then(res => {
      const { data } = res;

      if (data.code === "0000") {
        return data;
      }

      alert("부고 전송을 실패하였습니다");
      return null;
    })
    .catch(err => {
      alert("부고 전송을 실패하였습니다");
      console.error(err);
    });
};

const requestSendMessageUsers = async params => {
  return client
    .post(`/send/message/users`, params)
    .then(res => {
      const { data } = res;

      return data;
    })
    .catch(err => {
      alert("부고 전송을 실패하였습니다");
      console.error(err);
    });
};

const requestSendMessageList = async obituaryId => {
  return client
    .get(`/send/message-list?obituaryId=${obituaryId}`)
    .then(res => {
      const { data } = res;

      return data;
    })
    .catch(err => {
      alert("전송 메시지 내역 조회에 실패하였습니다");
      console.error(err);
    });
};

const requestReserveMessageUsers = async params => {
  return client
    .post(`/reserve/message/users`, params)
    .then(res => {
      const { data } = res;

      return data;
    })
    .catch(err => {
      alert("부고 예약을 실패하였습니다");
      console.error(err);
    });
};

const requestReseveMessageList = async obituaryId => {
  return client
    .get(`/reserve/message-list?obituaryId=${obituaryId}`)
    .then(res => {
      const { data } = res;

      return data;
    })
    .catch(err => {
      alert("예약 메시지 내역 조회에 실패하였습니다");
      console.error(err);
    });
};

const requestCancelReseveMessage = async params => {
  return client
    .post(`/reserve/cancel-message`, params)
    .then(res => {
      const { data } = res;

      if (data.code === "0000") {
        return data;
      }

      alert(data.message);
      return null;
    })
    .catch(err => {
      alert("예약 메시지 취소에 실패하였습니다");
      console.error(err);
    });
};

// 기일 알림 자동발송 on/off
const requestCircleAlarmToggle = async params => {
  return client
    .post(`/circle-alarm`, params)
    .then(res => {
      const { data } = res;

      if (data.code === "0000") {
        return data;
      }

      alert(data.message);
      return null;
    })
    .catch(err => {
      alert("기일 알림 설정 변경에 실패하였습니다");
      console.error(err);
    });
};

// 기일 알림 수동 발송 (특정 상주 1명)
const requestCircleAlarmSend = async params => {
  return client
    .post(`/circle-alarm/send`, params)
    .then(res => {
      const { data } = res;

      if (data.code === "0000") {
        return data;
      }

      alert(data.message);
      return null;
    })
    .catch(err => {
      alert("기일 알림 발송에 실패하였습니다");
      console.error(err);
    });
};

export {
  requestUserSave,
  requestUserDelete,
  requestUserBankDelete,
  requestSendMessage,
  requestSendMessageUsers,
  requestSendMessageList,
  requestReserveMessageUsers,
  requestReseveMessageList,
  requestCancelReseveMessage,
  requestCircleAlarmToggle,
  requestCircleAlarmSend
};
